<template>
  <div>
    <SlideShowSection />
    <LoginSection />
    <AboutSection />
    <ServicesSection />
    <ClientsSection />
  </div>
</template>

<script>
import SlideShowSection from "../components/sections/SlideShowSection.vue";
import LoginSection from "../components/sections/LoginSection.vue";
import AboutSection from "../components/sections/AboutSection.vue";
import ServicesSection from "../components/sections/ServicesSection.vue";
import ClientsSection from "../components/sections/ClientsSection.vue";

export default {
  components: {
    SlideShowSection,
    LoginSection,
    AboutSection,
    ServicesSection,
    ClientsSection,
  },
};
</script>
